import { Stack, Text } from '@mantine/core';
import { DetailCard, type WaRendererProps } from './primitives';

/**
 * A catalog product / product-list share. Previously these had no renderer at
 * all and showed as the bare string "🛍 Product".
 *
 * The Cloud API sends only catalog + retailer identifiers on these webhooks —
 * no title, price or image — so this lists exactly what Meta provided rather
 * than inventing product detail.
 */
export function ProductCard({ view }: WaRendererProps) {
  const p = view.product;
  if (!p) return null;
  const isList = view.subtype === 'product_list';
  return (
    <DetailCard title={isList ? '🛍️ Product list' : '🛍️ Product'}>
      <Stack gap={2}>
        {p.sectionTitles.map((t) => (
          <Text key={t} size="xs" fw={600}>
            {t}
          </Text>
        ))}
        {p.retailerIds.slice(0, 5).map((id) => (
          <Text key={id} size="xs" c="dimmed" lineClamp={1}>
            {id}
          </Text>
        ))}
        {p.retailerIds.length > 5 && (
          <Text size="xs" c="dimmed">
            +{p.retailerIds.length - 5} more
          </Text>
        )}
        {p.catalogId && (
          <Text size="xs" c="dimmed">
            Catalog {p.catalogId}
          </Text>
        )}
      </Stack>
    </DetailCard>
  );
}
